<template>
  <div
    class="d-flex flex-column flex-sm-row align-center justify-center mt-10 ml-auto mb-10 exclude-from-print"
  >
    <v-btn
      class="exclude-from-print mr-0 mr-sm-4"
      @click="qrStore.qrCodeContent = []"
      >Go Back</v-btn
    >
    <v-btn
      class="exclude-from-print mt-4 mt-sm-0"
      color="primary"
      prepend-icon="mdi-printer"
      @click="handlePrint"
    >
      Print Labels
    </v-btn>
  </div>
  <v-card
    min-height="600px"
    class="pa-8 jazel-card"
    flat
    v-for="(item, i) in carData"
    :key="item.vin"
    :data-testid="`qr-print-card-${i}`"
  >
    <v-card-text
      class="text-center"
      :style="`color:${productSettings.typographySettings.markupTextColor}; line-height:${productSettings.typographySettings.markupLineHeight}${productSettings.typographySettings.markupLineHeightUnit}; font-weight:${productSettings.typographySettings.markupTextWeight}; font-size:${productSettings.typographySettings.markupFontSize}${productSettings.typographySettings.markupFontSizeUnit}`"
    >
      <div>
        <!-- Above image area: prefer custom image when toggled, otherwise logo -->
        <template
          v-if="
            productSettings.useCustomImageAbove &&
            (productSettings.imageUrl ||
              productSettings.aboveImageSettings.file)
          "
        >
          <div class="mb-4">
            <img
              :src="
                productSettings.imageUrl ||
                previewImage(productSettings.aboveImageSettings.file, 'above')
              "
              :width="productSettings.aboveImageSettings.width + 'px'"
              :height="
                productSettings.aboveImageSettings.height === 'auto'
                  ? 'auto'
                  : productSettings.aboveImageSettings.height + 'px'
              "
              :class="{
                'ml-auto': productSettings.aboveImageSettings.align === 'right',
                'mr-auto': productSettings.aboveImageSettings.align === 'left',
                'mx-auto':
                  productSettings.aboveImageSettings.align === 'center',
              }"
              alt="Above QR Code Image"
              :style="{ maxWidth: '100%' }"
            />
          </div>
        </template>
        <template v-else>
          <!-- Brand Image (Company Logo) - should display above QR code -->
          <div
            v-if="productSettings.showBrandImage"
            class="mb-4"
            :style="{
              display: 'flex',
              justifyContent:
                productSettings.aboveImageSettings.align === 'left'
                  ? 'flex-start'
                  : productSettings.aboveImageSettings.align === 'right'
                    ? 'flex-end'
                    : 'center',
            }"
          >
            <img
              v-if="productSettings.brandImage"
              :src="productSettings.brandImage"
              :width="productSettings.aboveImageSettings.width || 200"
              :height="productSettings.aboveImageSettings.height || 'auto'"
              :data-testid="`brand-logo-${i}`"
              alt="Company Logo"
              :style="{ maxWidth: '100%' }"
            />
            <!-- Fallback text if no logo is available -->
            <div
              class="text-h6 font-weight-bold"
              v-if="!productSettings.brandImage"
            >
              {{ logoDisplayText }}
            </div>
          </div>
        </template>
        <div v-if="productSettings.aboveTextSettings.text.length > 0">
          <p
            :class="{
              'text-left': productSettings.aboveTextSettings.align === 'left',
              'text-center':
                productSettings.aboveTextSettings.align === 'center',
              'text-right': productSettings.aboveTextSettings.align === 'right',
            }"
            :style="`line-height:${productSettings.typographySettings.markupLineHeight}${productSettings.typographySettings.markupLineHeightUnit}`"
          >
            {{ productSettings.aboveTextSettings.text }}
          </p>
        </div>
      </div>
      <img
        :src="qrStore.qrCodeContent[i].QR"
        alt="QR Code"
        width="350px"
        :style="{ maxWidth: '100%' }"
        class="mx-auto"
        :data-testid="`qr-code-${i}`"
      />
      <div>
        <div v-if="productSettings.belowImageSettings.file">
          <img
            :src="
              previewImage(productSettings.belowImageSettings.file, 'below')
            "
            :width="productSettings.belowImageSettings.width + 'px'"
            :height="
              productSettings.belowImageSettings.height === 'auto'
                ? 'auto'
                : productSettings.belowImageSettings.height + 'px'
            "
            :class="{
              'ml-auto': productSettings.belowImageSettings.align === 'right',
              'mr-auto': productSettings.belowImageSettings.align === 'left',
              'mx-auto': productSettings.belowImageSettings.align === 'center',
            }"
            alt="Below QR Code Image"
            :style="{ maxWidth: '100%' }"
          />
        </div>
        <div v-if="productSettings.belowTextSettings.text.length > 0">
          <p
            :class="{
              'text-left': productSettings.belowTextSettings.align === 'left',
              'text-center':
                productSettings.belowTextSettings.align === 'center',
              'text-right': productSettings.belowTextSettings.align === 'right',
            }"
          >
            {{ productSettings.belowTextSettings.text }}
          </p>
        </div>
      </div>
      <!-- vehicle title -->
      <div
        v-if="
          productSettings.vehicleTitleSettings.selectedVehicleTitles &&
          productSettings.vehicleTitleSettings.selectedVehicleTitles.length >
            0 &&
          carData &&
          carData.length > 0
        "
        data-testid="vehicle-title-section"
        class="vehicle-title-container"
        :class="{
          'text-left': productSettings.vehicleTitleSettings.align === 'left',
          'text-center':
            productSettings.vehicleTitleSettings.align === 'center',
          'text-right': productSettings.vehicleTitleSettings.align === 'right',
        }"
      >
        <span
          v-for="(titleItem, index) in productSettings.vehicleTitleSettings
            .selectedVehicleTitles"
          :key="titleItem"
          class="px-1 vehicle-title-item"
        >
          {{ (item as any)[(titleItem as string).toLowerCase()] || '' }}
        </span>
      </div>
      <div
        v-if="
          productSettings.vehicleTitleSettings.displayCarVin &&
          carData &&
          carData.length > 0
        "
        data-testid="vehicle-vin-display"
        :class="{
          'text-left': productSettings.vehicleTitleSettings.align === 'left',
          'text-center':
            productSettings.vehicleTitleSettings.align === 'center',
          'text-right': productSettings.vehicleTitleSettings.align === 'right',
        }"
      >
        VIN: {{ item.vin }}
      </div>
      <div
        v-if="
          productSettings.vehicleTitleSettings.displayCarStockNumber &&
          carData &&
          carData.length > 0 &&
          item.stockNumber
        "
        data-testid="vehicle-stock-display"
        :class="{
          'text-left': productSettings.vehicleTitleSettings.align === 'left',
          'text-center':
            productSettings.vehicleTitleSettings.align === 'center',
          'text-right': productSettings.vehicleTitleSettings.align === 'right',
        }"
      >
        Stock#: {{ item.stockNumber }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useQrCodeStore } from '@/store/qrCodeStore'
import type { TCarData } from '@/types'
import { useProductSettingsStore } from '@/store/productSettings'
import { useAccountSettingsStore } from '@/store/accountSettings'

const qrStore = useQrCodeStore()
const accountSettings = useAccountSettingsStore()

const props = defineProps<{
  carData: TCarData[]
}>()

const handlePrint = () => {
  if (typeof window === 'undefined') return
  try {
    const pageName = 'letter-portrait'
    document.documentElement.setAttribute('data-page', pageName)

    const cleanup = () => {
      document.documentElement.removeAttribute('data-page')
    }

    if ('onafterprint' in window) {
      const handler = () => {
        cleanup()
        window.removeEventListener('afterprint', handler as any)
      }
      window.addEventListener('afterprint', handler as any)
    } else {
      setTimeout(cleanup, 1000)
    }

    window.print()
  } catch (e) {
    console.error('Print failed', e)
  }
}

const productSettings = useProductSettingsStore()

const aboveImageUrl = ref('')
const belowImageUrl = ref('')

const logoDisplayText = computed(() => {
  const settings = accountSettings.getAccountSettings()
  return settings?.config?.accountName || settings?.accountName || ''
})

const previewImage = (file: File | undefined, type: string) => {
  if (!file) return ''
  if (type === 'above') {
    return (aboveImageUrl.value = URL.createObjectURL(file))
  }
  if (type === 'below') {
    return (belowImageUrl.value = URL.createObjectURL(file))
  }
  return ''
}
</script>

<style>
/* Prevent word breaking in vehicle titles */
.vehicle-title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.25rem;
}

.vehicle-title-item {
  word-break: keep-all;
  overflow-wrap: break-word;
  hyphens: none;
  display: inline-block;
}

@media print {
  /* Reset all margins and padding for print */
  * {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Ensure body and html have no spacing */
  body,
  html {
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
  }

  .exclude-from-print {
    display: none;
  }

  /* Hide Jazel-specific header elements */
  .jazel-app-container,
  .jazel-header,
  .jazel-nav,
  .jazel-toolbar {
    display: none !important;
    position: absolute !important;
    left: -9999px !important;
    width: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
  }

  /* Hide any other potential spacing elements */
  .v-app-bar,
  .v-toolbar,
  .v-navigation-drawer,
  .v-main,
  .v-container,
  .v-row,
  .v-col,
  [class*='v-'] {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Target specific Vuetify spacing classes that might cause gaps */
  .mt-10,
  .mt-8,
  .mt-6,
  .mt-4,
  .mt-2,
  .pt-10,
  .pt-8,
  .pt-6,
  .pt-4,
  .pt-2,
  .my-10,
  .my-8,
  .my-6,
  .my-4,
  .my-2,
  .py-10,
  .py-8,
  .py-6,
  .py-4,
  .py-2 {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Hide any buttons or action elements that might cause spacing */
  .v-btn,
  .action-buttons,
  .print-buttons,
  .header-actions {
    display: none !important;
  }

  /* Ensure logo and content are visible during printing */
  .jazel-card .v-card-text {
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    min-height: 100vh !important;
  }

  /* Center each print card vertically on page */
  .jazel-card {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    min-height: 100vh !important;
    height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    position: static !important;
    top: auto !important;
    transform: none !important;
  }

  /* No special positioning for first page */
  .jazel-card:first-of-type {
    position: static !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
  }

  /* Ensure no spacing on any child elements of the first page */
  .jazel-card:first-of-type * {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Remove top forcing; use vertical centering */
  .jazel-card:first-of-type {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  /* Ensure v-card-text has no top spacing */
  .jazel-card .v-card-text {
    margin-top: 0 !important;
    padding-top: 0 !important;
    position: relative !important;
    top: 0 !important;
  }

  /* Ensure brand logo is visible during printing */
  .jazel-card .v-img {
    display: block !important;
    visibility: visible !important;
  }

  /* Ensure all images are visible during printing */
  .jazel-card img,
  .jazel-card .v-img {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    max-width: none !important;
    max-height: none !important;
  }

  /* Debug: Add border to logo container during print */
  .jazel-card .v-card-text > div:first-child {
    border: 1px solid transparent !important;
  }

  /* Ensure logo container is visible and properly sized during print */
  .jazel-card .v-card-text > div:first-child .v-img {
    min-height: 50px !important;
    min-width: 100px !important;
    display: block !important;
    visibility: visible !important;
  }

  /* Ensure fallback text is visible during print */
  .jazel-card .text-h6 {
    display: block !important;
    visibility: visible !important;
    font-size: 18px !important;
    font-weight: bold !important;
  }
}

@media print {
  .jazel-card {
    page-break-inside: avoid;
  }

  /* Ensure first page starts at very top */
  @page :first {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  /* Ensure all pages have no top margin */
  @page {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
}

/* Consistency overrides for print layout */
@media print {
  @page {
    margin: 0;
  }

  .jazel-card {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: always !important;
    display: table !important;
    width: 100% !important;
    height: 100vh !important;
    min-height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
    border: 0 !important;
  }

  .jazel-card:last-child {
    page-break-after: auto !important;
  }

  /* Center vertically without altering line-height */
  .jazel-card .v-card-text {
    display: table-cell !important;
    vertical-align: middle !important;
    text-align: center !important;
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
    min-height: 0 !important;
  }
}

@media print {
  html[data-page='letter-portrait'] .jazel-card {
    width: 8.5in !important;
    height: 11in !important;
    box-sizing: border-box;
    margin: 0 auto !important;
  }
  html[data-page='letter-landscape'] .jazel-card {
    width: 11in !important;
    height: 8.5in !important;
    box-sizing: border-box;
    margin: 0 auto !important;
  }
  html[data-page='a4-portrait'] .jazel-card {
    width: 210mm !important;
    height: 297mm !important;
    box-sizing: border-box;
    margin: 0 auto !important;
  }
  html[data-page='a4-landscape'] .jazel-card {
    width: 297mm !important;
    height: 210mm !important;
    box-sizing: border-box;
    margin: 0 auto !important;
  }
}

/* Final overrides to avoid vh/table conflicts and center content */
@media print {
  html[data-page] .jazel-card {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    height: auto !important;
    min-height: 100% !important;
  }

  html[data-page] .jazel-card .v-card-text {
    display: block !important;
    height: auto !important;
    min-height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}

/* Simple top spacing for each printed page */
@media print {
  .jazel-card {
    padding-top: 10% !important;
  }
}
</style>
